import React from 'react';
import styled from 'styled-components';

const Icon = styled.div`
    width: 24px;
    height: 24px;
    svg {
        stroke: #fff;
        fill: none;
        stroke-width: 6;
    }
`;

function IconMenuDefault(props) {
    return (
        <Icon>
            <svg viewBox="0 0 64 64">
                <path
                    strokeLinejoin="bevel"
                    d="M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994"
                />
                <path strokeLinejoin="bevel" d="m 5.1969746,31.909063 53.8166424,0" />
                <path
                    strokeLinejoin="bevel"
                    d="M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698"
                />
            </svg>
        </Icon>
    );
}

function IconMenuClose(props) {
    return (
        <Icon>
            <svg viewBox="0 0 64 64">
                <path strokeLinejoin="bevel">
                    <animate
                        attributeName="d"
                        dur=".25s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994"
                        to="M12.972944,50.936147C12.972944,50.936147,51.027056,12.882035,51.027056,12.882035"
                        fill="freeze"
                    />
                </path>
                <path strokeLinejoin="bevel" strokeOpacity="1" d="m 5.1969746,31.909063 53.8166424,0">
                    <animate
                        attributeName="stroke-opacity"
                        dur=".125s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="1"
                        to="0"
                        fill="freeze"
                    />
                </path>
                <path strokeLinejoin="bevel">
                    <animate
                        attributeName="d"
                        dur=".25s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698"
                        to="M12.972944,12.882035000000002C12.972944,12.882035000000002,51.027056,50.936147,51.027056,50.936147"
                        fill="freeze"
                    />
                </path>
            </svg>
        </Icon>
    );
}

function IconMenuOpen(props) {
    return (
        <Icon>
            <svg viewBox="0 0 64 64">
                <path strokeLinejoin="bevel">
                    <animate
                        attributeName="d"
                        dur=".25s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="M12.972944,50.936147C12.972944,50.936147,51.027056,12.882035,51.027056,12.882035"
                        to="M5.0916789,20.818994C5.0916789,20.818994,58.908321,20.818994,58.908321,20.818994"
                        fill="freeze"
                    />
                </path>
                <path strokeLinejoin="bevel" strokeOpacity="1" d="m 5.1969746,31.909063 53.8166424,0">
                    <animate
                        attributeName="stroke-opacity"
                        dur=".125s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="0"
                        to="1"
                        fill="freeze"
                    />
                </path>
                <path strokeLinejoin="bevel">
                    <animate
                        attributeName="d"
                        dur=".25s"
                        repeatCount="1"
                        calcMode="spline"
                        keySplines=".1,.8,.2,1"
                        from="M12.972944,12.882035000000002C12.972944,12.882035000000002,51.027056,50.936147,51.027056,50.936147"
                        to="M5.0916788,42.95698C5.0916788,42.95698,58.908321,42.95698,58.908321,42.95698"
                        fill="freeze"
                    />
                </path>
            </svg>
        </Icon>
    );
}

export { IconMenuDefault, IconMenuClose, IconMenuOpen };



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/svg/MenuIconSVG.js
 **/